import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ErrorHTML from 'components/common/form/ErrorHTML';
import SpinCenter from 'components/common/SpinCenter';

export default class ModalLoader extends Component {
    static propTypes = {
        children: PropTypes.node,
        refresh: PropTypes.func,
        meta: PropTypes.object.isRequired,
        className: PropTypes.string,
    };

    render() {
        const { refresh, meta, children, className } = this.props;

        return (meta.error || meta.pending) ?
            (
                <div className={`panel-view ${className}`}>
                    { meta.error && <ErrorHTML meta={meta} refresh={refresh} /> }
                    { meta.pending && <SpinCenter /> }
                </div>
            ) : <div className={className}>
                { children }
            </div>;
    }
}
